/*
 * @FileName       : report.service.ts
 * @Version        : 1.0
 * @DateOfCreation : 04/17/2020
 * @Author         : $u^^!t @ FFF Enterprises
 * @Dependencies   : N/A
 * @Description    : Report Service to perform all reports data call.
 *
 * Copyright (c) 2020, FFF Enterprises. All rights reserved.
 */

import {
	InvoicesList,
	PatchInvoiceAbwDto,
	PatchInvoiceOmitDto,
	PatchInvoiceReadyStatusFilterDto,
	SendAbwReminderEmail,
	TransmitToSapRequest,
} from '../models/invoices/invoices';
import { INVOICES } from '../constants/api.url';
import { HttpResponse, ResultSet } from '../models/common/result.set';
import Api from '../lib/api';
import TimestampNormalizer from '../lib/timestamp-normalizer';
import axios from 'axios';

export class InvoicesService {
	private static instance: InvoicesService;
	private constructor() {}

	public static getInstance(): InvoicesService {
		if (!InvoicesService.instance) {
			InvoicesService.instance = new InvoicesService();
		}
		return InvoicesService.instance;
	}

	public fetchInvoices = async (params: any | null): Promise<HttpResponse<ResultSet<InvoicesList>>> => {
		let invoiceResponse = await Api.get(INVOICES.LIST, params);
		const timestampNormalizer = new TimestampNormalizer(invoiceResponse.data.results, true);
		invoiceResponse.data.results = timestampNormalizer.convertToLocal('InvoiceDate');
		return invoiceResponse;
	};

	//for converge/elevon hosted payment!
	public getPaymentSessionToken = async (payload: any): Promise<HttpResponse<any>> => {
		const payloadToPost: any = {
			customerCode: payload.ZzinvPayer,
			amount: payload.InvoiceAmount,
			invoiceNumber: payload.InvoiceNumber,
		}

		if (payload.manufacturerName) {
			payloadToPost.manufacturerName = payload.manufacturerName
		}


		return await Api.post(INVOICES.SESSION_TOKEN, payloadToPost);
	};

	public paymentConfirmation = async (payment: any): Promise<HttpResponse<any>> => {
		return await Api.post(INVOICES.PAYMENT_CONFIRMATION, payment);
	};

	public getInvoiceRequests = async (params: any): Promise<HttpResponse<any>> => {
		return await Api.post(`${INVOICES.INVOICE_REQUESTS}/list`, params);
	};

	public patchInvoiceRequestAbw = async (payload: Array<PatchInvoiceAbwDto>): Promise<HttpResponse<any>> => {
		return await Api.patch(INVOICES.INVOICE_REQUESTS + '/abwSelection', payload);
	};

	public patchInvoiceRequestOmittal = async (payload: PatchInvoiceOmitDto): Promise<HttpResponse<any>> => {
		return await Api.patch(INVOICES.INVOICE_REQUESTS + '/' + payload.invoiceId + '/omit', {
			omittedReason: payload.omittedReason,
			omittedNote: payload.omittedNote ? payload.omittedNote : '',
		});
	};

	public patchInvoiceRequestOmittalBulk = async (payload: any): Promise<HttpResponse<any>> => {
		return await Api.patch(INVOICES.INVOICE_REQUESTS_BULK + '/bulkOmit', {
			omittedReason: payload.omittedReason,
			omittedNote: payload.omittedNote ? payload.omittedNote : '',
			rgaNumber: payload.rgaNumber || undefined,
			invoiceIds: payload.invoiceIds
		});
	};

	public patchMakeAllInvoicesReady = async (filter?: PatchInvoiceReadyStatusFilterDto): Promise<HttpResponse<any>> => {
		return await Api.patch(INVOICES.INVOICE_REQUESTS + '/makeReady', filter);
	};

	public sendAbwReminderEmail = async (payload: SendAbwReminderEmail): Promise<HttpResponse<any>> => {
		return await Api.post(INVOICES.INVOICE_REQUESTS + '/abwSelectionReminder', payload);
	};

	public transmitRequestsToSap = async (payload: TransmitToSapRequest): Promise<HttpResponse<any>> => {
		return await Api.post(INVOICES.INVOICE_REQUESTS + '/transmit', payload);
	};

	public updateInvoiceStatus = async (id: number, status: string): Promise<HttpResponse<any>> => {
		return await Api.patch(INVOICES.INVOICE_REQUESTS + `/${id}/status/${status}`, {});
	};

	public downloadInvoicePdf = async(invoiceId: string) => {
		const token = localStorage.getItem('id_token');
		const { data } = await axios.get(INVOICES.LIST + `/pdf/${invoiceId}`,  { 
			headers: {
				Authorization: 'Bearer ' + token,
			},
			responseType: 'blob'
		});
		const url = window.URL.createObjectURL(data); 
		const a = document.createElement('a');
		a.href = url;
		// a.target = '_blank';
		a.download = `${invoiceId}.pdf`; 
		document.body.appendChild(a);
		a.click();
		window.URL.revokeObjectURL(url);
	}
}
